const MANAGE_CATEGORIES = {
  GET_CATEGORIES: "CUSTOMERS:GET_CATEGORIES",
};

export default MANAGE_CATEGORIES;
